import React, {
  createContext,
  useState,
  useEffect,
  useLayoutEffect,Text
} from 'react';
import { Navigate, Route, Routes, Link, matchPath, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as authService from '../api/api';

import { getMessages,getTcmMessages, updateObject } from '../../shared/utils/utility';
import LocalStorageService from '../../shared/services/localStorageService';
import AsyncStorage from "@react-native-async-storage/async-storage";

import { useStateWithCallbackLazy } from 'use-state-with-callback';

export const AuthContext = createContext();

const defaultUser = {
  isLoggedIn: false,
  email: "",
  token: "",
  userMenuDefinitionCodes:[],
  userRoles:[]
};
const AuthContextProvider = (props) => {
  let navigate = useNavigate();
 
  //const [authUser2, setAuthUser2] = useStateWithCallback(defUser);
  //const [authUser, setAuthUser] = useStateWithCallback(defaultUser);
 // const [authUser, setDataPromiseAuthUser, setAuthUser] = useStatePromise(defaultUser);
  //const [authStatusReported, setAuthStatusReportedPromise, setAuthStatusReported] = useStatePromise(false);
  const [authStatusReported, setAuthStatusReported] = useStateWithCallbackLazy(false);
  const [authUser, setAuthUser] = useStateWithCallbackLazy(defaultUser);
  useEffect(() => {
    try {
      const cookieData = new LocalStorageService().authData;
   
     // console.log("try üstü:" + JSON.stringify(cookieData)+"___"+Object.keys(cookieData).length);
      if (Object.keys(cookieData).length>0 ) {
       
        changesetAuthUser(cookieData);
          changeAuthReport(true);
        console.log("auth if girdi :" + JSON.stringify(cookieData));
       
      } else {
        changesetAuthUser(defaultUser);
          changeAuthReport(true);
          //console.log("auth elseee girdi :");
      }
    } catch (error) {
      // console.log(
      //   "cookiaa error 11:"  + error
      // );
      changesetAuthUser(defaultUser);
        changeAuthReport(true);
       
      // expected output: ReferenceError: nonExistentFunction is not defined
      // Note - error messages will vary depending on browser
    }
    

     
  }, []);
 
  const changesetAuthUser = (val) => {
    setAuthUser(val, (currentCount) => {
      //  console.log('No threshold reached.changesetAuthUser'+JSON.stringify(currentCount));
    });
};
  const changeAuthReport = (val) => {
    setAuthStatusReported(val, (currentCount) => {
        //console.log('No threshold reached.changeAuthReport'+currentCount);
    });
};
const loginUserrrrr = async (username, password) => {
  return new Promise((resolve) => {

 

      const user = {...defaultUser};
      user.isLoggedIn = true;
      user.email = "admin@admin.com";
      user.userId = "222";
      user.name="isim";
      user.surname="soyiism";
      user.token = "hJgs443JKgf9453gfadsG";
      user.userMenuDefinitionCodes=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];
      user.userRoles="admin";
      // user.userMenuDefinitionCodes.push(33);//sifre degistirme sayfasina girerken bakmiyoruz
      // user.userMenuDefinitionCodes.push(28);//profil degistirme sayfasi
      user.userMenuDefinitionCodes.push(0);// yönetim paneli herkese açık sayfalar
      changesetAuthUser(user);
      changeAuthReport(true);
 //   setAuthUser2(defUser);
        console.log("setAuthStatusReportedPromise"+ JSON.stringify(user));
         storeUserSession(user);
         resolve(1);  
  })
};
  const loginUser = async (username, password) => {
    return new Promise((resolve) => {

      authService.login(username, password).then((res) => {
        if (res.isSuccess) {
     

        const user = {...defaultUser};
        user.isLoggedIn = true;
        user.email = username;
        // user.userId = res.data.userId;
         user.name=username;//res.data.name;
         user.surname="";
        // user.surname=res.data.surname;
         user.token = res.value.token;
         user.roles=res.value.roles;
        // user.userMenuDefinitionCodes=res.data.userMenuDefinitionCodes;
        // user.userRoles=res.data.userRoles;
        // user.userMenuDefinitionCodes.push(33);//sifre degistirme sayfasina girerken bakmiyoruz
        // user.userMenuDefinitionCodes.push(28);//profil degistirme sayfasi
        user.userMenuDefinitionCodes.push(0);// yönetim paneli herkese açık sayfalar
        changesetAuthUser(user);
        changeAuthReport(true);
   //   setAuthUser2(defUser);

          console.log("setAuthStatusReportedPromise"+ JSON.stringify(user));
    
          
           storeUserSession(user);
       
          resolve(1);
        } else {
          changesetAuthUser(defaultUser);
          setAuthStatusReported(true);
            console.log("login hata:"+JSON.stringify(res))
            toast.error("Hata: " + getTcmMessages(res.error));
            resolve(0);              
        }
      });
    })
  };
  const logoutUser = async () => {
    // new LocalStorageService().logout();
    await AsyncStorage.removeItem("authdata");
    changesetAuthUser(defaultUser);
      setAuthStatusReported(true);
      navigate("/login", { replace: true });
   
  };
  async function storeUserSession(user) {
    try {
      const jsonValue = JSON.stringify(user)
      await AsyncStorage.setItem("authdata", jsonValue);
    } catch (error) {
       console.log("hata çıktı:"+error)
    }
  }

  return (
    <AuthContext.Provider
      value={{
        authUser,
        loginUser,logoutUser,authStatusReported
      }}
    >
      {authStatusReported && props.children }
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;